import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "current-color",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0002 13.4312L5.93073 9.36178L6.91683 8.36178L9.30573 10.7507V3.33398H10.6946V10.7507L13.0835 8.36178L14.0696 9.36178L10.0002 13.4312ZM3.3335 16.6673V12.459H4.72237V15.2784H15.278V12.459H16.6668V16.6673H3.3335Z",
		fill: "inherit"
	})
});
export default SvgImport;
